(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9344],{

/***/ 4895:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/login",
      function () {
        return __webpack_require__(65110);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js
var Link = __webpack_require__(47034);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./src/components/authentication/AuthFormWrapper.tsx
var AuthFormWrapper = __webpack_require__(6195);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(74509);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js
var notistack_esm = __webpack_require__(73400);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/components/form/FormikCheckField.tsx
var FormikCheckField = __webpack_require__(2072);
// EXTERNAL MODULE: ./src/components/form/FormikTextField.tsx
var FormikTextField = __webpack_require__(9952);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
// EXTERNAL MODULE: ./src/hooks/useIsMountedRef.ts
var useIsMountedRef = __webpack_require__(60128);
// EXTERNAL MODULE: ./src/utils/password-validation.ts
var password_validation = __webpack_require__(9679);
;// CONCATENATED MODULE: ./src/components/authentication/change-password/index.tsx













function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ChangePasswordFormSchema = es/* object */.Ry({
    email: es/* string */.Z_().max(255).required("Email is required"),
    newPassword: password_validation/* PasswordValidation */.T,
    passwordConfirm: es/* string */.Z_().oneOf([
        es/* ref */.iH("newPassword"),
        null
    ], "Passwords must match").required("Required"),
    policy: es/* boolean */.O7().oneOf([
        true
    ], "You must agree to the Terms and Conditions").required(),
    submit: es/* string */.Z_()
});
var ChangePasswordForm = function(param1) {
    var email = param1.email, oldPassword = param1.oldPassword, setLoginValues = param1.setLoginValues, setChangePassword = param1.setChangePassword;
    var isMountedRef = (0,useIsMountedRef/* default */.Z)();
    var newPassword = (0,useAuth/* default */.Z)().newPassword;
    var itemsRef = (0,react.useRef)([]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    (0,react.useEffect)(function() {
        itemsRef.current = itemsRef.current.slice(0, 6);
    }, []);
    var handleNewPasswordSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values, param) {
            var setErrors, setSubmitting, ref, error, _message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setErrors = param.setErrors, setSubmitting = param.setSubmitting;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return newPassword({
                            email: values.email,
                            new_password: values.newPassword,
                            old_password: oldPassword
                        });
                    case 4:
                        enqueueSnackbar(t("change_password.success"), {
                            variant: "success"
                        });
                        setLoginValues({
                            email: values.email,
                            password: values.newPassword
                        });
                        setChangePassword(false);
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        if (isMountedRef.current) {
                            ;
                            error = _ctx.t0;
                            ;
                            setErrors({
                                submit: (_message = (ref = error.response) === null || ref === void 0 ? void 0 : ref.data.message) !== null && _message !== void 0 ? _message : error.message
                            });
                            setSubmitting(false);
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function handleNewPasswordSubmit(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            email: email,
            oldPassword: "",
            newPassword: "",
            policy: false,
            passwordConfirm: ""
        },
        validationSchema: ChangePasswordFormSchema,
        onSubmit: handleNewPasswordSubmit,
        children: function(param) {
            var errors = param.errors, isSubmitting = param.isSubmitting, handleChange = param.handleChange, values = param.values;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "email",
                        autoFocus: true,
                        autoComplete: "email",
                        fullWidth: true,
                        label: t("change_password.email"),
                        margin: "normal",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "newPassword",
                        fullWidth: true,
                        autoComplete: "new-password",
                        label: t("change_password.new_password"),
                        margin: "normal",
                        type: "password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "passwordConfirm",
                        fullWidth: true,
                        autoComplete: "new-password",
                        label: t("change_password.new_password_confirm"),
                        margin: "normal",
                        type: "password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCheckField/* FormikCheckField */.D, {
                        checked: values.policy,
                        color: "primary",
                        name: "policy",
                        onChange: handleChange,
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            color: "textSecondary",
                            variant: "body2",
                            children: [
                                "I agree to the",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    color: "primary",
                                    component: "a",
                                    href: "https://privacyhorizon.com/terms-and-conditions/",
                                    target: "_blank",
                                    children: "Terms and Conditions"
                                }),
                                " ",
                                "and",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    color: "primary",
                                    component: "a",
                                    href: "https://privacyhorizon.com/privacy-notice/",
                                    target: "_blank",
                                    children: "Privacy Notice"
                                })
                            ]
                        })
                    }),
                    errors.submit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            error: true,
                            children: errors.submit
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            color: "secondary",
                            disabled: isSubmitting,
                            fullWidth: true,
                            size: "large",
                            type: "submit",
                            variant: "contained",
                            children: t("change_password.submit")
                        })
                    })
                ]
            });
        }
    }));
};

// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(22715);
;// CONCATENATED MODULE: ./src/components/form/FormikCodeField.tsx




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var FormikCodeField = function(props) {
    var formik = (0,formik_esm/* useFormikContext */.u6)();
    var itemsRef = react.useRef([]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
        name: props.name,
        children: function(param) {
            var field = param.field, meta = param.meta;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            columnGap: "16px",
                            display: "grid",
                            gridTemplateColumns: "repeat(7, 1fr)",
                            py: 1
                        },
                        children: [
                            _toConsumableArray(Array(props.codeLength).keys()).map(function(ref, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    error: Boolean(Array.isArray(meta.touched) && meta.touched.length === props.codeLength && meta.error),
                                    fullWidth: true,
                                    inputRef: function(el) {
                                        itemsRef.current[i] = el;
                                    },
                                    name: "code[".concat(i, "]"),
                                    onBlur: function(e) {
                                        return field.onBlur(e);
                                    },
                                    onKeyDown: function(event) {
                                        if (event.code === "ENTER") {
                                            if (field.value[i]) {
                                                formik.setFieldValue("code[".concat(i, "]"), "");
                                                return;
                                            }
                                            if (i > 0) {
                                                formik.setFieldValue("code[".concat(i, "]"), "");
                                                itemsRef.current[i - 1].focus();
                                                return;
                                            }
                                        }
                                        if (Number.isInteger(parseInt(event.key, 10))) {
                                            formik.setFieldValue("code[".concat(i, "]"), event.key);
                                            if (i < 5) {
                                                itemsRef.current[i + 1].focus();
                                            }
                                        }
                                    },
                                    onPaste: function(event) {
                                        var paste = event.clipboardData.getData("text");
                                        var pasteArray = paste.split("");
                                        if (pasteArray.length !== props.codeLength) {
                                            return;
                                        }
                                        var valid = pasteArray.every(function(x) {
                                            return Number.isInteger(parseInt(x, 10));
                                        });
                                        if (valid) {
                                            formik.setFieldValue(props.name, pasteArray);
                                            itemsRef.current[5].focus();
                                        }
                                    },
                                    value: field.value[i],
                                    sx: {
                                        display: "inline-block",
                                        textAlign: "center",
                                        "& .MuiInputBase-input": {
                                            textAlign: "center"
                                        }
                                    },
                                    variant: "outlined"
                                }, "code-".concat(i));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "outlined",
                                onClick: function() {
                                    formik.setFieldValue(props.name, [
                                        "",
                                        "",
                                        "",
                                        "",
                                        "",
                                        ""
                                    ]);
                                },
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {},
                        children: Boolean(meta.touched && meta.error) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            error: true,
                            sx: {
                                mx: "14px"
                            },
                            children: "MFA Code is a required field"
                        })
                    })
                ]
            });
        }
    }));
};

// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(46648);
// EXTERNAL MODULE: ./src/requests/auth.ts
var auth = __webpack_require__(57298);
// EXTERNAL MODULE: ./src/requests/user.ts
var user = __webpack_require__(39632);
;// CONCATENATED MODULE: ./src/components/authentication/login/index.tsx
















function login_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function login_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                login_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                login_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var initialValues = {
    email: "",
    password: "",
    code: [
        "",
        "",
        "",
        "",
        "",
        ""
    ]
};
var LoginForm = function(param1) {
    var setVerifying = param1.setVerifying, setLoginValues = param1.setLoginValues, setChangePassword = param1.setChangePassword;
    var isMountedRef = (0,useIsMountedRef/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref2 = (0,useAuth/* default */.Z)(), resendConfirmationEmail = ref2.resendConfirmationEmail, login = ref2.login, confirmMFACode = ref2.confirmMFACode;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref1 = (0,react.useState)(false), requireMfa = ref1[0], setRequireMfa = ref1[1];
    var loginFormMfaSchema = es/* object */.Ry({
        email: es/* string */.Z_().required(t("login.email.error")),
        password: es/* string */.Z_().required(t("login.password.error")),
        submit: es/* string */.Z_(),
        code: es/* array */.IX().of(es/* string */.Z_().required()).required()
    });
    // @ts-expect-error No good way to get yup to work with empty array
    var loginFormSchema = es/* object */.Ry({
        email: es/* string */.Z_().required(t("login.email.error")),
        password: es/* string */.Z_().required(t("login.password.error")),
        submit: es/* string */.Z_(),
        code: es/* array */.IX().of(es/* string */.Z_())
    });
    var handleSubmitLogin = function() {
        var _ref = login_asyncToGenerator(runtime_default().mark(function _callee(values, param) {
            var setErrors, setSubmitting, status, currentSession, _organization_id, ref, error, _message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setErrors = param.setErrors, setSubmitting = param.setSubmitting;
                        _ctx.prev = 1;
                        status = null;
                        if (requireMfa) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 6;
                        return login({
                            email: values.email,
                            password: values.password
                        });
                    case 6:
                        status = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.next = 11;
                        return confirmMFACode({
                            email: values.email,
                            mfaCode: values.code.join("")
                        });
                    case 11:
                        status = _ctx.sent;
                    case 12:
                        if (isMountedRef.current) {
                            setSubmitting(false);
                        }
                        _ctx.t0 = status;
                        _ctx.next = _ctx.t0 === "FORCE_CHANGE_PASSWORD" ? 16 : _ctx.t0 === "NEED_MFA" ? 19 : _ctx.t0 === "CONFIRMED" ? 22 : _ctx.t0 === "NOT_CONFIRMED" ? 30 : 35;
                        break;
                    case 16:
                        setLoginValues({
                            email: values.email,
                            password: values.password
                        });
                        setChangePassword(true);
                        return _ctx.abrupt("break", 36);
                    case 19:
                        setRequireMfa(true);
                        setErrors({
                            submit: "MFA Code required"
                        });
                        return _ctx.abrupt("break", 36);
                    case 22:
                        _ctx.next = 24;
                        return (0,auth/* fetchCurrentSession */.X1)();
                    case 24:
                        currentSession = _ctx.sent;
                        ;
                        _ctx.next = 28;
                        return (0,user/* updateUser */.Nq)((_organization_id = currentSession.user.organization_id) !== null && _organization_id !== void 0 ? _organization_id : "", currentSession.user.user_id, {
                            confirmed: true,
                            last_login: new Date()
                        });
                    case 28:
                        router.push("/");
                        return _ctx.abrupt("break", 36);
                    case 30:
                        _ctx.next = 32;
                        return resendConfirmationEmail({
                            email: values.email
                        });
                    case 32:
                        setLoginValues({
                            email: values.email,
                            password: values.password
                        });
                        setVerifying(true);
                        return _ctx.abrupt("break", 36);
                    case 35:
                        router.push(routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN);
                    case 36:
                        _ctx.next = 41;
                        break;
                    case 38:
                        _ctx.prev = 38;
                        _ctx.t1 = _ctx["catch"](1);
                        if (isMountedRef.current) {
                            ;
                            error = _ctx.t1;
                            ;
                            setErrors({
                                submit: (_message = (ref = error.response) === null || ref === void 0 ? void 0 : ref.data.message) !== null && _message !== void 0 ? _message : error.message
                            });
                            setSubmitting(false);
                        }
                    case 41:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    38
                ]
            ]);
        }));
        return function handleSubmitLogin(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: initialValues,
        validationSchema: requireMfa ? loginFormMfaSchema : loginFormSchema,
        onSubmit: handleSubmitLogin,
        children: function(param) {
            var errors = param.errors, isSubmitting = param.isSubmitting;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "email",
                        autoFocus: true,
                        autoComplete: "email",
                        fullWidth: true,
                        label: t("login.email.useremail"),
                        margin: "normal",
                        type: "email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                        name: "password",
                        autoComplete: "password",
                        fullWidth: true,
                        label: t("login.password.label"),
                        margin: "normal",
                        type: "password"
                    }),
                    requireMfa && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "textSecondary",
                                variant: "subtitle2",
                                children: t("verify_mfa.verification_code")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikCodeField, {
                                codeLength: 6,
                                name: "code"
                            })
                        ]
                    }),
                    errors.submit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mt: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                            error: true,
                            children: errors.submit
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: isSubmitting,
                            fullWidth: true,
                            size: "large",
                            type: "submit",
                            variant: "contained",
                            color: "secondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    fontWeight: "900",
                                    color: "#333333"
                                },
                                children: t("login.loginbutton")
                            })
                        })
                    })
                ]
            });
        }
    }));
};

// EXTERNAL MODULE: ./src/components/authentication/verify-code/index.tsx + 1 modules
var verify_code = __webpack_require__(79776);
;// CONCATENATED MODULE: ./src/pages/auth/login.tsx












function login_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || login_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function login_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return login_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return login_arrayLikeToArray(o, minLen);
}
var Login = function() {
    var ref = _slicedToArray(react.useState(false), 2), verifying = ref[0], setVerifying = ref[1];
    var ref1 = _slicedToArray(react.useState(false), 2), changePassword = ref1[0], setChangePassword = ref1[1];
    var ref2 = _slicedToArray(react.useState({
        email: "",
        password: ""
    }), 2), loginValues = ref2[0], setLoginValues = ref2[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var user = (0,useAuth/* default */.Z)().user;
    var router = (0,next_router.useRouter)();
    react.useEffect(function() {
        if (user) {
            router.push("/");
        }
    }, [
        user,
        router
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: !changePassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthFormWrapper/* AuthFormWrapper */.f, {
            title: "Login",
            children: verifying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(verify_code/* VerifyCodeStep */.o, {
                loginValues: loginValues
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "space-between",
                            mb: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    display: "flex",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "textPrimary",
                                        gutterBottom: true,
                                        variant: "h4",
                                        children: t("login.title.title")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    display: "flex",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "textSecondary",
                                        variant: "body2",
                                        children: t("login.title.label")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            flexGrow: 1,
                            mt: 3
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {
                                setVerifying: setVerifying,
                                setLoginValues: setLoginValues,
                                setChangePassword: setChangePassword
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                pt: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: routes/* ROUTES.AUTH_FORGOT_PASSWORD */.Z.AUTH_FORGOT_PASSWORD,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        color: "textSecondary",
                                        variant: "body2",
                                        children: t("login.forgot_password")
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthFormWrapper/* AuthFormWrapper */.f, {
            title: t("change_password.title"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 3
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "textPrimary",
                                gutterBottom: true,
                                variant: "h4",
                                children: t("change_password.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "textSecondary",
                                variant: "body2",
                                children: t("change_password.subtitle")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        flexGrow: 1,
                        mt: 3
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePasswordForm, {
                        email: loginValues.email,
                        oldPassword: loginValues.password,
                        setLoginValues: setLoginValues,
                        setChangePassword: setChangePassword
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var login = (Login);


/***/ }),

/***/ 39632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nq": function() { return /* binding */ updateUser; },
/* harmony export */   "r4": function() { return /* binding */ createUser; },
/* harmony export */   "L": function() { return /* binding */ archiveOrganizationUser; },
/* harmony export */   "TR": function() { return /* binding */ addAuditorUserToOrg; },
/* harmony export */   "eR": function() { return /* binding */ removeAuditorUserFromOrg; },
/* harmony export */   "SZ": function() { return /* binding */ addEnterpriseUserToOrg; },
/* harmony export */   "IR": function() { return /* binding */ sendUserSetupInvitation; },
/* harmony export */   "PG": function() { return /* binding */ removeEntAdminFromOrg; }
/* harmony export */ });
/* harmony import */ var _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var clients_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21269);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
// Patch Client record
var updateUser = function() {
    var _ref = _asyncToGenerator(_tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(organizationId, userId, values) {
        var response;
        return _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return clients_axios__WEBPACK_IMPORTED_MODULE_1__/* .axiosClient.patch */ .Ud.patch("organization/".concat(organizationId, "/user/").concat(userId), values);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateUser(organizationId, userId, values) {
        return _ref.apply(this, arguments);
    };
}();
// Add Client record
var createUser = function() {
    var _ref = _asyncToGenerator(_tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(organizationId, values) {
        var response;
        return _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return clients_axios__WEBPACK_IMPORTED_MODULE_1__/* .axiosClient.post */ .Ud.post("organization/".concat(organizationId, "/user"), values);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createUser(organizationId, values) {
        return _ref.apply(this, arguments);
    };
}();
var archiveOrganizationUser = function() {
    var _ref = _asyncToGenerator(_tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(organizationId, userId) {
        var response;
        return _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return clients_axios__WEBPACK_IMPORTED_MODULE_1__/* .axiosClient.post */ .Ud.post("organization/".concat(organizationId, "/user/").concat(userId));
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function archiveOrganizationUser(organizationId, userId) {
        return _ref.apply(this, arguments);
    };
}();
var addAuditorUserToOrg = function() {
    var _ref = _asyncToGenerator(_tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(organizationId, userId) {
        var response;
        return _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return clients_axios__WEBPACK_IMPORTED_MODULE_1__/* .axiosClient.patch */ .Ud.patch("organization/".concat(organizationId, "/user/").concat(userId, "/auditor"));
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function addAuditorUserToOrg(organizationId, userId) {
        return _ref.apply(this, arguments);
    };
}();
var removeAuditorUserFromOrg = function() {
    var _ref = _asyncToGenerator(_tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(organizationId, userId) {
        var response;
        return _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return clients_axios__WEBPACK_IMPORTED_MODULE_1__/* .axiosClient["delete"] */ .Ud["delete"]("organization/".concat(organizationId, "/user/").concat(userId, "/auditor"));
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function removeAuditorUserFromOrg(organizationId, userId) {
        return _ref.apply(this, arguments);
    };
}();
var addEnterpriseUserToOrg = function() {
    var _ref = _asyncToGenerator(_tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(organizationId, userId) {
        var response;
        return _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return clients_axios__WEBPACK_IMPORTED_MODULE_1__/* .axiosClient.patch */ .Ud.patch("organization/".concat(organizationId, "/user/").concat(userId, "/enterprise"));
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function addEnterpriseUserToOrg(organizationId, userId) {
        return _ref.apply(this, arguments);
    };
}();
var sendUserSetupInvitation = function() {
    var _ref = _asyncToGenerator(_tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(organizationId, userId) {
        var response;
        return _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return clients_axios__WEBPACK_IMPORTED_MODULE_1__/* .axiosClient.post */ .Ud.post("organization/".concat(organizationId, "/user/").concat(userId, "/invite"));
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendUserSetupInvitation(organizationId, userId) {
        return _ref.apply(this, arguments);
    };
}();
var removeEntAdminFromOrg = function() {
    var _ref = _asyncToGenerator(_tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(organizationId, userId) {
        var response;
        return _tmp_tmp_2794_Rzt46eNUfS1E_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return clients_axios__WEBPACK_IMPORTED_MODULE_1__/* .axiosClient.post */ .Ud.post("organization/".concat(organizationId, "/user/").concat(userId, "/enterprise/remove"));
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function removeEntAdminFromOrg(organizationId, userId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [964,6664,3227,2305,4927,1551,5711,6432,9774,2888,179], function() { return __webpack_exec__(4895); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);